var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('GlobalTitle', {
    staticClass: "title-section",
    attrs: {
      "title": _vm.title,
      "text-color": _vm.textColor
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };